module.exports = __webpack_public_path__ + "static/media/seguradora_infinite.fd73e0f2.png";